<template>
    <v-container :class="{'v3_index_view':  $vuetify.breakpoint.mdAndUp, 'pa-0': $vuetify.breakpoint.smAndDown}">
        <heading-view :right-column="show_table_view"></heading-view>

        <add-view v-if="show_add_view"></add-view>
        <table-view v-if="show_table_view"></table-view>

        <!--<v-btn fab bottom right dark fixed color="accent" v-if="show_table_view" @click="showAddForm()">-->
            <!--<v-icon>mdi-plus</v-icon>-->
        <!--</v-btn>-->
    </v-container>
</template>

<script>
    import {serverBus} from "../../main";

    import AddView from "../add/AddView";
    import TableView from '../table/TableView'
    import HeadingView from '../heading/HeadingView'

    export default {

        components: {
            AddView,
            TableView,
            HeadingView,
        },

        created: function () {
            let table = this.$route.params.table;
            this.$store.commit('setTable', table);

            this.show_add_view = this.$route.matched[0].name === 'AddView';
            this.show_table_view = this.$route.matched[0].name === 'TableView';

            serverBus.$on('show-add-form', (item) => {
                if (this.$useDialog()) {
                    serverBus.$emit('show-add-edit-dialog', table, item);
                } else {
                    this.$navigate('/admin/' + table + '/add' + (item.id > 0 ? '/' + item.id : ''));
                }
            });
        },

        methods: {
            showAddForm: function () {
                serverBus.$emit('show-add-form', {id: -1});
            },
        },

        beforeDestroy() {
            serverBus.$off('show-add-form');
        },

        data: function () {
            return {
                show_add_view: false,
                show_table_view: false
            };
        }
    }
</script>